import React, { useMemo, useState } from 'react';
import { v4 as UUID } from 'uuid';
import styles from './ExclusionFormSection.module.scss';
import {
  FormControl,
  FormLabel,
  Input,
  Button,
  Icon,
  IconList,
  List,
  ListItem,
  Text,
} from 'components/core';
import { Inline, Stack } from 'components/layout';
import { exclusionReasons } from 'pages/EligibilityCriteria/EligibilityCriteria';

type ExclusionFormSectionProps = {
  title: string;
  label: string;
  exclusions: exclusionReasons;
  onUpdate: () => void;
  onApiError: (errors: string[] | null) => void;
};

const ExclusionFormSection = ({
  title,
  label,
  exclusions,
}: ExclusionFormSectionProps) => {
  const describedById = useMemo(() => UUID(), []);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isSubmitting, setIsSubmitting] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [screenReaderNotification, setScreenReaderNotification] = useState('');

  return (
    <form onSubmit={() => null} className={styles.form}>
      <Stack spacing={3} className={styles.formGroup} component="fieldset">
        <Text
          className={styles.formLegend}
          variant="neutral"
          component="legend"
          size="sm"
        >
          {title}
        </Text>
        <Inline alignY="top" spacing={3}>
          <FormControl error={''}>
            <FormLabel isVisuallyHidden>{label}</FormLabel>
            <Input size="sm" aria-describedby={describedById} />
          </FormControl>

          <Button
            isLoading={isSubmitting}
            htmlType="submit"
            type="brand"
            variant="outline"
            aria-label="Add"
            size="sm"
          >
            Add
          </Button>
        </Inline>

        <div aria-live="polite" role="status" className={styles.visuallyHidden}>
          {screenReaderNotification}
        </div>

        <Stack spacing={2} component={List} className={styles.highlightList}>
          {exclusions.map((exclusion) => (
            <Inline
              alignX="left"
              key={exclusion.reason}
              spacing={3}
              component={ListItem}
            >
              <Text size="sm" className={styles.highlight} variant="neutral">
                {exclusion.reason}
              </Text>
              <Button
                iconOnly
                htmlType="button"
                type="neutral"
                variant="ghost"
                size="sm"
                isLoading={false}
                onClick={() => null}
                aria-label={`Delete ${
                  exclusion.reason
                } from ${title.toLowerCase()} words`}
              >
                <Icon size="md" icon={IconList.light.faTrashCan} />
              </Button>
            </Inline>
          ))}
        </Stack>
      </Stack>
    </form>
  );
};

export default ExclusionFormSection;
